import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Constants from '../constants/Constants';

const PageContainer = styled.div`
  margin: 0 auto;
  background: #D1CDC8;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Title = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-size: 3rem;
  color: #333;
  margin-bottom: 30px;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: relative;
  display: inline-block;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    width: 60%;
    height: 2px;
    background: linear-gradient(to right, #D1CDC8, #4A4A4A);
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 20px;
  }
`;

const AreaTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 2rem;
  color: #333;
  margin-top: 30px;
  margin-bottom: 20px;
  text-align: center;
`;

const RoomList = styled.ul`
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

const RoomItem = styled.li`
  width: calc(33.33% - 20px);
  max-width: 300px;

  @media (max-width: 1024px) {
    width: calc(50% - 20px);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const RoomLink = styled(Link)`
  display: block;
  padding: 20px;
  background-color: #E7E6E4;
  color: #333;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);

  &:hover {
    background-color: #61916e;
    color: white;
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  }
`;

function HomePage() {
  const [cases, setCases] = useState({});
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    // Add URL search params check
    const queryParams = new URLSearchParams(window.location.search);
    setShowAll(queryParams.has('show_all'));

    const fetchCasesData = async () => {
      try {
        const response = await fetch(`${Constants.get.SERVER_URL}/cases`);

        if (!response.ok) {
          throw new Error('Failed to fetch case data');
        }
        const rawData = await response.json();
        const data = Object.values(rawData);

        const groupedRooms = data.reduce((acc, caseData) => {
          if (caseData.district !== '' && caseData.rooms !== undefined) {
            const allRoomsRented = caseData.rooms.every(room => room.vacant_for_rent === '入住中');
            // Modified condition to include showAll parameter
            if (!allRoomsRented || currentPath === '/roomall' || showAll) {
              if (!acc[caseData.district]) {
                acc[caseData.district] = [];
              }
              if (caseData.id !== 'A0013')
                acc[caseData.district].push(caseData);
            }
          }
          return acc;
        }, {});

        setCases(groupedRooms);

      } catch (error) {
        console.error('Error fetching case data:', error);
        return null;
      }
    };
    fetchCasesData();

    // setRooms(groupedRooms);
  }, [currentPath, showAll]); // Added showAll to dependencies

  // Sort areas, putting 'Other' at the end
  const sortedAreas = Object.keys(cases).sort((a, b) => {
    if (a === 'Other') return 1;
    if (b === 'Other') return -1;
    return a.localeCompare(b);
  });

  return (
    <PageContainer>
      <Title>租案清單</Title>
      {sortedAreas.map((area) => (
        <div key={area}>
          <AreaTitle>{area}</AreaTitle>
          <RoomList>
            {
              cases[area].map(cs => {
                return (
                  <RoomItem key={cs.id}>
                    <RoomLink to={`/room/${cs.id}${window.location.search}`}>{cs.property_name}</RoomLink>
                  </RoomItem>
                );
              })
            }
          </RoomList>
        </div>
      ))}
    </PageContainer>
  );
}

export default HomePage;